import type { App as VueApp, Plugin } from "vue";

import InfoRequest from "@LandingPage/Scripts/Components/InfoRequest/InfoRequest.vue";
import LandingLightBuildingRequest from "@LandingPage/Scripts/Components/LandingLightBuildingRequest/InfoRequest.vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";

// Directives

import CloseDialog from "@LandingPage/Scripts/Directives/CloseDialog/CloseDialog";

const AppConfig: Plugin = {
    install(app: VueApp) {
        app.component("lan-inforequest", InfoRequest);
        app.component("llb-request", LandingLightBuildingRequest);

        app.component("app-cookietoast", CookieToast);

        app.directive("close-dialog", CloseDialog);
    }
};

export default AppConfig;